import AuthForgotPasswordForm from "./AuthForgotPasswordForm";

export default AuthForgotPasswordForm;
